"use client";
import Typed from "react-typed";

type Props = {
  text: string;
  typeSpeed?: number;
  backSpeed?: number;
  className?: string;
};

export const TypingAnimation = ({
  text,
  typeSpeed = 100,
  backSpeed = 20,
  className
}: Props) => {
  const staticFirstText = text.split("[")[0];
  const staticLastText = text.split("]")[1];
  const dynamicPart = text.match(/\[(.*?)\]/)?.[1] || "";
  const words = dynamicPart.split(",");

  return (
    <div>
      {staticFirstText}
      <span className={className}>
        <Typed
          strings={words}
          typeSpeed={typeSpeed}
          backSpeed={backSpeed}
          loop
        />
      </span>
      {staticLastText}
    </div>
  );
};
